import {BaseFragment} from "../shared/BaseFragment";
import React from "react";
import {Login} from "../shared/Login";
import {App} from "./App";
import {getMemberAuth} from "../shared/auth";
import {Action} from "../shared/types";
import {HeaderButtons} from "./Components";

export class LoginFragment extends BaseFragment {

  protected async fetchOnMount(forceReload?: boolean): Promise<void> {
    const auth = getMemberAuth();
    if (auth.auth?.currentUser) {
      this.props.path.navigate("/");
    }
  }

  protected renderContainerContent(): React.ReactElement | null {
    return <>
      <Login config={App.CONTEXT.getAppConfig().loginConfig}/>
      <HeaderButtons actions={[new Action("Use as Guest", () => this.props.path.navigate("/"))]}/>
    </>;
  }
}